import React from 'react'
import { useMall } from '../../../../store'
import { getFixedSchedule } from './FixedScheduleInfo'

import './FixedScheduleSteps.scss'

const STEP_COUNT = 4

// 고정 일정 매장의 예약 진행도 (인원 선택 → 정보 입력 → 결제 → 완료)
export default function FixedScheduleSteps({ step }) {
	const mallId = useMall(state => state.mall?.mall_id)
	if (!getFixedSchedule(mallId))
		return null

	return (
		<div className="fixed-schedule-steps">
			{Array.from({ length: STEP_COUNT }, (_, idx) => (
				<i key={idx} className={idx < step
					? 'on'
					: ''} />
			))}
		</div>
	)
}
